import React, { useState } from "react";
import { Link } from "react-router-dom";
import { X } from "lucide-react";
import { useSiteConfig } from "../context/SiteConfigContext";

const DISMISS_KEY = "venus_sale_banner_dismissed";

const AnnouncementBar = () => {
  const { discount, loaded } = useSiteConfig();
  const [dismissed, setDismissed] = useState(() => {
    try { return sessionStorage.getItem(DISMISS_KEY) === "1"; } catch { return false; }
  });

  if (!loaded || !discount?.active || dismissed) return null;

  const dismiss = () => {
    try { sessionStorage.setItem(DISMISS_KEY, "1"); } catch { /* no-op */ }
    setDismissed(true);
  };

  return (
    <div
      data-testid="announcement-bar"
      className="relative z-50 bg-[var(--espresso)] text-[var(--cream)] px-4 py-2.5 text-center"
    >
      <p className="text-[10px] sm:text-xs tracking-[0.2em] uppercase inline-flex items-center justify-center flex-wrap gap-x-2 gap-y-1">
        <span className="text-[var(--copper)]">✦</span>
        <span>{discount.message || `${discount.percent}% off sitewide`}</span>
        <Link to="/shop" className="underline underline-offset-4 decoration-[var(--copper)] hover:text-[var(--copper)] transition-colors">
          Shop the sale
        </Link>
      </p>
      <button
        onClick={dismiss}
        aria-label="Dismiss sale announcement"
        data-testid="announcement-dismiss"
        className="absolute right-3 top-1/2 -translate-y-1/2 p-1 text-[var(--cream)]/60 hover:text-[var(--cream)] transition-colors"
      >
        <X className="w-3.5 h-3.5" />
      </button>
    </div>
  );
};

export default AnnouncementBar;
